export default __webpack_public_path__ + "static/media/dizz-logo.b8ee26e4.svg";